@if (rule()) {
  <p-card class="custom-card">
    <div class="section-title">Dane podstawowe</div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div class="md:col-span-1">
        <div class="field-label">Identyfikator</div>
        <div class="field-value">{{ rule()!.id }}</div>
      </div>
      <div class="md:col-span-2">
        <div class="field-label">Data utworzenia</div>
        <div class="field-value">
          {{ rule()!.dataUtworzenia | date: 'yyyy-MM-dd HH:mm:ss' }}
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      <div class="md:col-span-1">
        <div class="field-label">Data początku obowiązywania</div>
        <div class="field-value">
          {{ rule()!.dataOd | date: 'yyyy-MM-dd HH:mm:ss' }}
        </div>
      </div>
      <div class="md:col-span-2">
        <div class="field-label">Data końca obowiązywania</div>
        <div class="field-value whitespace-pre-line">
          {{ rule()!.dataDo | date: 'yyyy-MM-dd HH:mm:ss' }}
        </div>
      </div>
    </div>
  </p-card>

  <p-card class="custom-card mt-6">
    <div class="section-title">Treść regulaminu</div>
    <div class="mt-6">
      <div class="rule-content">
        <div class="ql-editor" [innerHTML]="rule()!.tresc! | safeHtml"></div>
      </div>
    </div>
  </p-card>

  <div class="flex flex-wrap justify-end gap-2 mt-6">
    <p-button
      label="Wstecz"
      styleClass="customInfoButton outlined"
      (click)="onBack()"
    />
    @if (canEdit()) {
      <p-button
        label="Edytuj"
        styleClass="customInfoButton"
        (click)="onEdit()"
      />
    }
  </div>
}
